
<template>
    <input
      type="text"
      @focus="selectAll"
      v-bind:value="valor"
      @input="updateValue($event.target.value)"
      @blur="formatValue"
      ref="valor"
      @keydown.enter="focusControl">
</template>

<script>
import { SysVars } from '../main'
import { hasHiddenParent } from '../shared/utils';

export default {
    props: {
      value: { Number, String },
      max: {
        type: Number, default: Number.MAX_SAFE_INTEGER || 9007199254740991, required: false,
      },
      min: {
        type: Number, default: Number.MIN_SAFE_INTEGER || -9007199254740991, required: false
      },
      minus: {
        type: Boolean, default: false, required: false
      },
    },

    data () {
      return {
        valor: this.value,
        focused: false
      }
    },

    mounted () {
      //this.formatValue()
    },

    created () {

    },

    methods: {

      updateValue: function(value) {
        //emite somente valores numericos validos
        let v = this.$refs.valor.value
        v = v.replace(/\D/g, "")
        v = this.$strToFloat(v, 0)
        this.$emit('input', v)
      },

      selectAll: function(event) {
        this.focused = true
        // Workaround for Safari bug
        // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
        setTimeout(function() {
          event.target.select()
        }, 0)
        this.$emit('focus')
      },

      formatRemove: function () {
        var vlr = this.$refs.valor.value
        this.$refs.valor.value = vlr.replace(/\./g, '')
      },

      formatValue: function() {
        let v = this.$refs.valor.value
        this.$refs.valor.value = this.$strToFloat(v, 0)
        this.focused = false
        this.$emit('blur')
      },

      focusControl: function (event) {
          event.preventDefault();
          var thisIndex = jQuery(this.$el).index(SysVars.sFocusControl)
          var next = thisIndex + 1
          var obj = jQuery(SysVars.sFocusControl)
          let found = false
          for (var x = next; x < obj.length; x++) {
            if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
              jQuery(obj[x]).focus()
              found = true
              break
            }
          }
          if (!found) {
            for (var x = 0; x < obj.length; x++) {
              if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
                jQuery(obj[x]).focus()
                found = true
                break
              }
            }
          }

          this.$emit('keyenter')
      },

      focus: function () {
          if (this.$refs.valor) {
              this.$refs.valor.focus()
          }
      },

    },
    watch: {
      value: function (value) {
        // if (!this.focused) {
        //   this.$refs.valor.value = String(value).replace('.', ',')
        // }
        this.$refs.valor.value = String(value).replace('.', ',')
      }
    }

}
</script>

<style scoped>
  input {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/input-number.vue